import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";

import { Pagination } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Editbtn from "../Skills/images/circum_edit.svg";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import { Toast, ToastContainer } from "react-bootstrap";
import { baseURL } from "../../config";

const AnnouncementTable = () => {
  const [posts, setPosts] = useState({ announcement: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedannouncement, setEditedAnnouncement] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [announcementToDelete, setGradesToDelete] = useState(null);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/getannouncement`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.announcement)) {
          setPosts({ announcement: data.announcement });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (announcementId) => {
    try {
      setGradesToDelete(announcementId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleSaveEditedGrade = async () => {
    try {
      const response = await axios.post(
        `${baseURL}//announcementsupdate?id=${editedannouncement.id}`,
        editedannouncement
      );
      console.log("Updated Announcement:", response.data);
      const updatedAnnouncement = posts.announcement.map((announcement) => {
        if (announcement.id === editedannouncement.id) {
          return editedannouncement;
        }
        return announcement;
      });
      setPosts({ announcement: updatedAnnouncement });
      setShowEditModal(false);
      setShowToast(true);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Announcement not found. Please try again.");
      } else {
        console.error("Error updating Announcement:", error);
      }
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(
        `${baseURL}//deleteannouncement?id=${announcementToDelete}`
      );
      const updatedAnnouncement = posts.announcement.filter(
        (announcement) => announcement.id !== announcementToDelete
      );
      setPosts({ announcement: updatedAnnouncement });
      setShowDeleteModal(false);
      setShowToast(true);
    } catch (error) {
      console.error("Error deleting Announcement:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleStatusUpdate = async (announcementId, newStatus) => {
    try {
      const response = await axios.get(
        `${baseURL}/announcementquicksupdate?id=` +
          announcementId +
          `&status=` +
          newStatus
      );
      console.log("Updated Announcement:", response.data);
      const updatedAnnouncementstatus = posts.announcement.map(
        (announcement) => {
          if (announcement.id === announcementId) {
            return { ...announcement, status: newStatus };
          }
          return announcement;
        }
      );
      setPosts({ announcement: updatedAnnouncementstatus });
      setShowToast(true);
      // Redirect to a new location after updating
    } catch (error) {
      console.error("Error updating Announcement status:", error);
    }
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.announcement.slice(
    indexOfFirstPost,
    indexOfLastPost
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleEdit = (announcement) => {
    setEditedAnnouncement(announcement);
    setShowEditModal(true);
  };

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">Announcement List</h4>
        </div>
        <div className="col-lg-6 text-end bg-white ">
          <a href="/Announcement" className="text-decoration-none text-white">
            <button type="button" className="btn btn-danger rounded-pill">
              Add Announcement +
            </button>
          </a>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Message</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((announcement, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td className="col-3">{announcement.title}</td>
              <td className="col-5">{announcement.message}</td>
              <td className="text-center">
                <ReactBootstrap.Button
                  variant={
                    announcement.status === "Active"
                      ? "success"
                      : "outline-success"
                  }
                  onClick={() => handleStatusUpdate(announcement.id, "Active")}
                >
                  Active
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  variant={
                    announcement.status === "Inactive"
                      ? "danger"
                      : "outline-danger"
                  }
                  onClick={() =>
                    handleStatusUpdate(announcement.id, "Inactive")
                  }
                >
                  Inactive
                </ReactBootstrap.Button>
              </td>
              <td className="text-center">
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleEdit(announcement)}
                >
                  <img src={Editbtn} alt="Edit" />
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  variant="danger"
                  onClick={() => handleDelete(announcement.id)}
                >
                  <img src={deletebtn} alt="Delete" />
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>

      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          <p className="text-danger fw-bold">
            Are you sure you want to delete this Announcement?
          </p>
          Deleting Announcement will also impact the Announcement based
          templates.
          <b>
            If there are no templates for this Announcement you can delete
            safely.
          </b>
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>
      <div>
        {/* Your existing component code */}

        <ToastContainer position="top-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      {showEditModal && editedannouncement && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title className="text-center">
              Edit Announcement
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <div>
              <label>Title :</label>
              <textarea
                className="form-control"
                rows="2"
                type="text"
                value={editedannouncement.title}
                onChange={(e) =>
                  setEditedAnnouncement({
                    ...editedannouncement,
                    title: e.target.value,
                  })
                }
              />
            </div>
            <br />
            <div>
              <label>Message :</label>
              <textarea
                rows={3}
                className="form-control"
                type="text"
                value={editedannouncement.message}
                onChange={(e) =>
                  setEditedAnnouncement({
                    ...editedannouncement,
                    message: e.target.value,
                  })
                }
              />
            </div>
            {/* <div>
                            <label>Status :</label>
                            <input type="text" className="form-control" value={editedannouncement.status} onChange={(e) => setEditedAnnouncement({ ...editedannouncement, status: e.target.value })} />
                        </div> */}
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedGrade}
            >
              Update
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.announcement.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default AnnouncementTable;
